import { getAnalyticsTaskAttributeMetric as getDiagramAnalyticsTaskMetric } from '@process-advisor/process-miner/processMiner/processMiner';

export type TaskMetricProps = {
    Metric?: string;
}

export const getAnalyticsTaskAttributeMetric = (): TaskMetricProps => getDiagramAnalyticsTaskMetric();
